import cx from 'classnames';
import { ContentImage } from 'components/ContentImage/ContentImage';
import React, { FC } from 'react';

import type { ContentImageEntry } from 'api/contentful/contentTypes.cloverdotcom';
import { useTranslation } from 'react-i18next';
import styles from './ItemImage.module.scss';
import moreImagesIcon from 'images/icons/more-images-icon.svg';

interface IItemImageProps {
  isImageClickable: boolean;
  isFirstStep: boolean;
  image?: ContentImageEntry;
  handleImageClick: () => void;
}

export const ItemImage: FC<IItemImageProps> = ({
  isImageClickable,
  isFirstStep,
  image,
  handleImageClick,
}) => {
  const { t } = useTranslation();

  return isImageClickable ? (
    <>
      <button
        onClick={handleImageClick}
        className={styles.clickable}
        aria-label={t('build-your-own.item.imageClickLabel')}
      >
        <img
          src={moreImagesIcon}
          className={styles.moreImagesIcon}
          width={28}
          height={28}
          aria-hidden
          alt="More Images Icon"
        />
        <ContentImage className={styles.byoImage} entry={image} isLazyLoad={false} />
      </button>
    </>
  ) : (
    <ContentImage
      className={cx(styles.byoImage, { [styles.firstStep]: isFirstStep })}
      entry={image}
      isLazyLoad={false}
    />
  );
};
